declare const google;
const distributors = [];
function locateDistributors() {
	document.addEventListener("DOMContentLoaded", function (event) {
		navigator.geolocation.getCurrentPosition(function (position) {
			loadMapAtCenter(new google.maps.LatLng(position.coords.latitude, position.coords.longitude));
		}, function (error) {
			console.error(error.message);
			loadMapAtCenter(new google.maps.LatLng(41.8358255, -87.7772543));
		});
	});
}
async function loadMapAtCenter(latlng) {
	let escapeSpan = document.createElement("span");
	let template = document.querySelector("#vb-template-info_window") as HTMLTemplateElement;
	let results = document.querySelector(".vb--results") as HTMLDivElement;
	let map = new google.maps.Map(document.getElementById("map"), {
		center: latlng,
		zoom: 10
	});
	var vbPage = 1;
	while (vbPage > 0) {
		let json = await (await window.fetch(`?rest_route=/wp/v2/vb_distributor&per_page=100&page=${vbPage}&_fields=type,title,address,latitude,longitude,phone,email,website,area`)).json();
		if (!json["data"]) {
			distributors.push(...json);
			vbPage++;
		} else {
			vbPage = 0;
			document.getElementById("map").classList.remove("vb--loading");
			results.innerHTML = "";
		}
	}
	let geocoder = new google.maps.Geocoder();
	let search = document.getElementById("vb-locate_distributor").querySelector("input[type=\"search\"]") as HTMLInputElement;
	let submit = document.getElementById("vb-locate_distributor").querySelector("input[type=\"submit\"]") as HTMLInputElement;
	submit.addEventListener("click", function (event) {
		event.preventDefault();
		if (window["dataLayer"]) {
			window["dataLayer"].push({
				event: "distributor_locator-search",
			});
		}
		geocoder.geocode({
			address: search.value,
			region: "US"
		}, function (results, status) {
			if (status === 'OK') {
				map.setCenter(results[0].geometry.location);
			}
		});
	});
	let showResults = function () {
		let bounds = map.getBounds();
		geocoder.geocode({
			location: map.getCenter(),
		}, function (center, status) {
			if (status === "OK") {
				results.innerHTML = "";
				let addressComponents = center.flatMap(address => address.address_components);
				let country = addressComponents.find(comp => comp.types.includes("country"))?.short_name;
				let state = addressComponents.find(comp => comp.types.includes("administrative_area_level_1"))?.short_name;
				let postalCode = addressComponents.find(comp => comp.types.includes("postal_code"))?.short_name;
				let visible = distributors.filter(distributor => bounds.contains(new google.maps.LatLng(distributor.latitude, distributor.longitude)));
				visible.push(...distributors.filter(distributor => {
					if (distributor.type === "area") {
						let areas = Object.keys(JSON.parse(distributor.area));
						return areas.find(area => country === "US" && area.length === 2 ? area === state : area === postalCode);
					} else {
						return false;
					}
				}));
				if (visible.length > 0) {
					visible.sort((a, b) => a.title.rendered.localeCompare(b.title.rendered)).forEach(distributor => {
						escapeSpan.innerHTML = distributor.title.rendered;
						let name = escapeSpan.textContent;
						let fragment = template.content.cloneNode(true) as DocumentFragment;
						fragment.querySelector(".vb--distributor-name").textContent = name;
						if (distributor.type !== "area") {
							fragment.querySelector(".vb--distributor-address").textContent = distributor.address;
						}
						if (distributor.phone) {
							let phone = fragment.querySelector(".vb--distributor-phone") as HTMLAnchorElement;
							phone.href = `tel:${distributor.phone}`;
							phone.textContent = distributor.phone;
						}
						results.appendChild(document.importNode(fragment, true));
					});
				} else {
					results.innerHTML = "<p class=\"vb--empty\"><strong>There aren&rsquo;t any distributors nearby.</strong> Zoom the map out to expand the search range, or view our <a href=\"/national-distributors/\">national distributors</a>.</p>";
				}
			}
		});
	};
	map.addListener("bounds_changed", showResults);
	distributors.forEach(distributor => {
		escapeSpan.innerHTML = distributor.title.rendered;
		let name = escapeSpan.textContent;
		if (distributor.type !== "area") {
			let marker = new google.maps.Marker({
				position: new google.maps.LatLng(distributor.latitude, distributor.longitude),
				map: map,
				title: name,
			});
			marker.addListener("click", function (event) {
				let fragment = template.content.cloneNode(true) as DocumentFragment;
				fragment.querySelector(".vb--distributor-name").textContent = name;
				fragment.querySelector(".vb--distributor-address").textContent = distributor.address;
				if (distributor.phone) {
					let phone = fragment.querySelector(".vb--distributor-phone") as HTMLAnchorElement;
					phone.href = `tel:${distributor.phone}`;
					phone.textContent = distributor.phone;
				}
				let info = new google.maps.InfoWindow({
					content: document.importNode(fragment, true)
				});
				info.open(map, marker);
			});
		}
	});
	showResults();
}
